import { render, staticRenderFns } from "./LiteracyBadgeList.vue?vue&type=template&id=11fa6902"
import script from "./LiteracyBadgeList.vue?vue&type=script&lang=js"
export * from "./LiteracyBadgeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports